import { gql } from "graphql-request";
// Add all courseMonetisation flow relatd queries here

// get all courseFeedPost
export const GET_ALL_COURSES_QUERY = gql`
  query ($input: AllCourseInput!) {
    allcourses(input: $input) {
      edges {
        id
        thumbnail
        name
        description
        subtitle
        public
        owner {
          name
          id
          totalCourses
          totalLearners
          signature
          social_links
          short_bio
        }
        files {
          id
          course_id
          media
        }
        urls {
          url
          id
        }
        active
        free
        price
        discounted_price
        payment_link
        isLive
        meeting_link
        start_time
        repeat
        start_date
        repeat_until
        repeat_weekdays
        repeat_monthly_date
        prerequisites
        learning_outcomes
        tags
        preview_video
        preview_video_link
        timezone
        members_count
        classes {
          id
          name
        }
        is_enrolled
        section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
          isPublished
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          is_active
          #max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
        course_mins
        total_lecs
        progress_bar
        course_level
        is_draft
      }
      total_count
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

export const GET_COURSE_QUERY = gql`
  query ($id: ID!) {
    getCoursesById(id: $id) {
      id
      thumbnail
      name
      description
      subtitle
      public
      owner {
        name
        id
        profile_link
        totalCourses
        totalLearners
        signature
        social_links
        short_bio
      }
      user_profile {
        id
        name
        profile_pic
      }
      files {
        id
        course_id
        media
      }
      urls {
        url
        id
      }
      active
      free
      price
      discounted_price
      currency
      members_count
      classes {
        id
        name
      }
      is_enrolled
      section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
          isPublished
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          is_active
          max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
      progress_bar
      course_level
      is_draft
      payment_link
      meeting_link
      start_time
      repeat
      start_date
      repeat_until
      repeat_weekdays
      repeat_monthly_date
      isLive
      prerequisites
      learning_outcomes
      tags
      preview_video
      preview_video_link
      timezone
    }
  }
`;


export const GET_COURSE_PROGRESS_QUERY = gql`
  query ($courseID: ID!) {
    getCoursesById(id: $courseID) {
      progress_bar
    }
  }
`;
